// cfgactions

const mutations = {
	getCfgActions(state, objects) {
		state.cfgactions = objects;
  	},

};

export default mutations;